import React from 'react'
import {
  EditorState,
  convertFromRaw,
  CompositeDecorator
} from 'draft-js'
import Editor from 'draft-js-plugins-editor'
import { markdownToDraft } from 'markdown-draft-js'
import styled from 'styled-components'
import findLinkEntities from '../../helpers/findLinkEntities'
import Files from './Files'
import NotesUtil from '../../helpers/NotesUtil'

const Container = styled.div`
  a {
      color: #3399CC;
      &:hover { cursor: pointer; }
    }
  }
  .newParagraph {
    margin-bottom: 12px;
  }
  ul {
    margin-left: 20px;
  }
  min-width: 400px;
  margin-right: 10px;
  line-height: 21px;
`
const FilesContainer = styled.div`
  margin-top: 15px;
  display: flex;
`

const Link = ({ contentState, entityKey, children }) => {
  const { url } = contentState.getEntity(entityKey).getData()

  return (
    <a rel="nofollow noreferrer" href={url} target="_blank">
      {children}
    </a>
  )
}

const decorator = new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: Link
  }
])

const convertToEditorState = md  => {
  const editorContent = md.length > 0 ? md : ''
  const convertedState = convertFromRaw(markdownToDraft(editorContent))

  return EditorState.createWithContent(convertedState, decorator)
}

export default ({ md, files}) => (
  <Container>
    <Editor
      editorState={convertToEditorState(md)}
      readOnly
      onChange={()=> {}}
      blockStyleFn={NotesUtil.customBlockStyleFn}
      />
      {files !== undefined && files.length > 0 && (
        <FilesContainer>
          <Files files={files} hideClose published/>
        </FilesContainer>
      )}
  </Container>
)
